import react, {useEffect, useState} from 'react';
import Loader from "../../../../Loader/Loader";
import React from "react";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import NotFoundData from "../../../../Images/no-data-found.webp";
import {toast} from "react-toastify";
import './approve.css'
import Moment from "moment";
import BottomMenu from "../../../layout/bottomMenu";

const PjpRejectedList = ({
                             history,
                             getAM,
                             allAm = [],
                             pjpPending,
                             PJPPendingList = [],
                             pjpPendingApprove,
                             PJPApprovalDetails = [],
                             match
                         }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [userId, setUserId] = useState('')
    const [open, setOpen] = useState(false);
    const [filterInputList, setFilterInputList] = useState([{}])
    const [isFilterRemove, setIsRemoveFilter] = useState(false)
    const [roleId, setRoleId] = useState('')

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getAM(2);
            setUserId(window.localStorage.user_id)
            await pjpPending(match?.params?.request_id, 3)

            setIsLoading(false)
        })();
    }, []);

    const handleFetchTollDetails = async (userId) => {
        setIsLoading(true)
        setUserId(userId)
        await pjpPending(match?.params?.request_id, 3, filterInputList)
        setIsLoading(false)
    }

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        await pjpPending(match?.params?.request_id, 3, filterInputList)
        setIsLoading(false)
    }

    const handleFilter = async (key, value, stringValue = '') => {

        const list = [...filterInputList]
        list[0][key] = value
        setFilterInputList(list)
    }

    const handleRemoveFilter = async (key) => {
        if (key !== '') {
            delete filterInputList[0][key]
            setFilterInputList(filterInputList)
            setIsLoading(true)
            if (match?.params?.user_id) {
                await pjpPending(match?.params?.user_id, 2, filterInputList)
            } else {
                await pjpPending(userId, 3, filterInputList)
            }

            setIsLoading(false)
        }
    }
    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Rejected PJP'}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            <div className="container-fluid bootstrap snippets bg-white">
                                {/*<div className="card">*/}
                                {/*    <div className="card-body">*/}
                                {/*<h4 className="card-title mb-3">Rejected PJP</h4>*/}
                                        <div className="col-sm-12 col-md-12 col-lg-12 d-flex">
                                            <h4 className="col-md-6 mt-4 header-title">
                                                PJP Rejected Request
                                            </h4>
                                            <div className="col-md-6 cs-pos mb-14">
                                                <button onClick={() => setOpen(!open)}
                                                        className="btn btn-sm btn-primary mr-1 mt-3 mr-4 btn-filter"
                                                        type="button"><i
                                                    className="fa fa-filter lh-35 pd-3"></i>
                                                </button>
                                            </div>
                                        </div>

                                        {filterInputList[0] !== undefined && Object.keys(filterInputList[0]).length > 0 &&
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <div className="row pd-filter-div">
                                                    <div className="col-md-12 col-sm-12 mt-6 d-flex">
                                                        <div className="applied-filter">
                                                            {Object.keys(filterInputList[0]).map((val, i) => {
                                                                return (
                                                                    <>
                                                            <span className="fd-1">
                                                                <span style={{textTransform: "capitalize"}}>
                                                                    {val.replaceAll("_", " ")}
                                                                </span>
                                                                {" - " + filterInputList[0][val]}
                                                                <i className="bi bi-x-circle" onClick={(e) => {
                                                                    handleRemoveFilter(val)
                                                                }}></i></span>
                                                                    </>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {!match?.params?.user_id &&
                                            <div className="default-tab">
                                                {allAm?.data &&
                                                    <select onChange={(e) => {
                                                        handleFetchTollDetails(e.target.value)
                                                    }} className="mb-5 col-md-12 col-sm-12 mt-6" style={{borderRadius:"10px"}}>
                                                        <option>Select AM</option>
                                                        {allAm?.data.map((val, i) => {
                                                            return (
                                                                <>
                                                                    <option
                                                                        value={val?.id}>{val?.name + "(" + val?.email + ")"}</option>
                                                                </>
                                                            )
                                                        })}
                                                    </select>
                                                }
                                            </div>
                                        }

                                <div className="row mt-10">
                                        {PJPPendingList?.data && PJPPendingList?.data.length > 0 && PJPPendingList?.data.map((value, ii) => {
                                            return (
                                                <>
                                                    {PJPPendingList?.data.length - 1 !== ii &&

                                                        <div className="col-md-4 col-sm-6">
                                                            <div className="card-big-shadow card-padding">
                                                                <div className="card card-just-text"
                                                                     data-background="color"
                                                                     data-color=""
                                                                     data-radius="none">
                                                                    <div className="content">
                                                                        <h6 className="category">
                                                                            <div className="header-ui-item-opp bg-green"
                                                                            >
                                                                                {value?.client_name}
                                                                            </div>

                                                                            {/*<div className="row">*/}
                                                                            {/*    <div className="col-10" style={{*/}
                                                                            {/*        color: "#000",*/}
                                                                            {/*        fontSize: "20px",*/}
                                                                            {/*        textAlign: "left",*/}
                                                                            {/*        paddingLeft: "20px"*/}
                                                                            {/*    }}>*/}
                                                                            {/*        <span*/}
                                                                            {/*            className="">{value?.fast_tag_toll_no}*/}
                                                                            {/*        </span>*/}
                                                                            {/*    </div>*/}
                                                                            {/*</div>*/}
                                                                            <div className="row list-view">
                                                                                <div className="mb-flex">
                                                                                    <div
                                                                                        className="col-md-6 col-sm-6 no-wrap">
                                                                                        <i className="fas fa-comment"></i>&nbsp;&nbsp;Plaza Id
                                                                                    </div>
                                                                                    <div className="col-md-6 col-sm-6">
                                                                                        <span className="trigger"
                                                                                              data-tooltip-id="1"
                                                                                              title={value?.fast_tag_toll_no}>
                                                                                            {value?.fast_tag_toll_no}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="mb-flex">
                                                                                    <div
                                                                                        className="col-md-6 col-sm-6 no-wrap">
                                                                                        <i className="fas fa-check-circle"></i>&nbsp;&nbsp;City
                                                                                    </div>
                                                                                    <div className="col-md-6 col-sm-6">
                                                                                        <span className="trigger"
                                                                                              data-tooltip-id="1"
                                                                                              title={value?.city_name}>
                                                                                            {value?.city_name}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="mb-flex">
                                                                                    <div
                                                                                        className="col-md-6 col-sm-6 no-wrap">
                                                                                        <i className="bi bi-building"></i>&nbsp;&nbsp;State
                                                                                    </div>
                                                                                    <div className="col-md-6 col-sm-6">
                                                                                        <span className="trigger"
                                                                                              data-tooltip-id="1"
                                                                                              title={value?.state_name}>
                                                                                            {value?.state_name}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="mb-flex">
                                                                                    <div
                                                                                        className="col-md-6 col-sm-6 no-wrap">
                                                                                        <i className="fas fa-check-circle"></i>&nbsp;&nbsp;Date
                                                                                    </div>
                                                                                    <div className="col-md-6 col-sm-6">
                                                                                        <span className="trigger"
                                                                                              data-tooltip-id="1"
                                                                                              title={value?.schedule_date}>
                                                                                            {value?.schedule_date}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <hr/>
                                                                        </h6>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    }
                                                </>
                                            )
                                        })}
                                </div>

                                        {PJPPendingList?.data && PJPPendingList?.data.length === 0 &&
                                            <div className="text-center">
                                                <img src={NotFoundData} className="not-found-data" alt={"not found"}/>
                                                <br/>
                                                <div style={{fontSize: "large", fontWeight: "400"}}>
                                                    No data found
                                                </div>
                                            </div>
                                        }
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    handleSubmitFilter={handleSubmitFilter}
                    filterContent={{data: [{'field': 'date', 'place_holder': 'from_date', 'values': ''}, {'field': 'date', 'place_holder': 'to_date', 'values': ''}]}}
                    handleFilter={handleFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>
        </>
    )
}

export default PjpRejectedList